var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 64H91V96H85V64Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104 77V83H72V77H104Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 57C40.9025 57 33.5 49.5975 33.5 40.5C33.5 31.4025 40.9025 24 50 24C59.0975 24 66.5 31.4025 66.5 40.5C66.5 49.5975 59.0975 57 50 57ZM50 30C44.21 30 39.5 34.71 39.5 40.5C39.5 46.29 44.21 51 50 51C55.79 51 60.5 46.29 60.5 40.5C60.5 34.71 55.79 30 50 30Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7045 68.0823C66.5059 63.0316 58.6002 60 50 60C30.15 60 14 76.15 14 96H20C20 79.4575 33.4575 66 50 66C56.9456 66 63.3473 68.3723 68.4375 72.3493L72.7045 68.0823Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/Register.5b297803.svg";
export { ForwardRef as ReactComponent };